export default {
  head: {
    title: 'WAP sessions billing',
    action: {
      create: {
        tooltip: 'Create new WAP report'
      },
      search: {
        tooltip: 'Search single session by Session Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search WAP billing session'
    },
    details: {
      title: 'WAP session details'
    }
  }
};
